/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
    StatusToJSONTyped,
} from './Status';
import type { StepMetadata } from './StepMetadata';
import {
    StepMetadataFromJSON,
    StepMetadataFromJSONTyped,
    StepMetadataToJSON,
    StepMetadataToJSONTyped,
} from './StepMetadata';
import type { ProductSpecificServiceRoleProperties } from './ProductSpecificServiceRoleProperties';
import {
    ProductSpecificServiceRolePropertiesFromJSON,
    ProductSpecificServiceRolePropertiesFromJSONTyped,
    ProductSpecificServiceRolePropertiesToJSON,
    ProductSpecificServiceRolePropertiesToJSONTyped,
} from './ProductSpecificServiceRoleProperties';
import type { Task } from './Task';
import {
    TaskFromJSON,
    TaskFromJSONTyped,
    TaskToJSON,
    TaskToJSONTyped,
} from './Task';
import type { ServiceRoleDefinition } from './ServiceRoleDefinition';
import {
    ServiceRoleDefinitionFromJSON,
    ServiceRoleDefinitionFromJSONTyped,
    ServiceRoleDefinitionToJSON,
    ServiceRoleDefinitionToJSONTyped,
} from './ServiceRoleDefinition';
import type { DocumentV2 } from './DocumentV2';
import {
    DocumentV2FromJSON,
    DocumentV2FromJSONTyped,
    DocumentV2ToJSON,
    DocumentV2ToJSONTyped,
} from './DocumentV2';

/**
 * 
 * @export
 * @interface ServiceRole
 */
export interface ServiceRole {
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    serviceRoleUid?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    serviceAgreementUid: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    partnerUid: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    domicileCountry?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceRole
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ServiceRole
     */
    validTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    justification?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    status?: string;
    /**
     * 
     * @type {ServiceRoleDefinition}
     * @memberof ServiceRole
     */
    serviceRoleDefinition: ServiceRoleDefinition;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    partnerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    partnerType?: string;
    /**
     * 
     * @type {Array<StepMetadata>}
     * @memberof ServiceRole
     */
    stepMetadata?: Array<StepMetadata>;
    /**
     * 
     * @type {Array<Task>}
     * @memberof ServiceRole
     */
    tasks?: Array<Task>;
    /**
     * 
     * @type {Array<DocumentV2>}
     * @memberof ServiceRole
     */
    documents?: Array<DocumentV2>;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRole
     */
    isEligible?: boolean;
    /**
     * 
     * @type {Array<Status>}
     * @memberof ServiceRole
     */
    statuses?: Array<Status>;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    processInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRole
     */
    closingProcessInstanceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRole
     */
    canBeDeactivated?: boolean;
    /**
     * Whether product-specific role attributes can be edited by the current user
     * @type {boolean}
     * @memberof ServiceRole
     */
    isEditable?: boolean;
    /**
     * Whether the role can be removed from product configuration by the current user
     * @type {boolean}
     * @memberof ServiceRole
     */
    isRemovable?: boolean;
    /**
     * 
     * @type {ProductSpecificServiceRoleProperties}
     * @memberof ServiceRole
     */
    productSpecificProperties?: ProductSpecificServiceRoleProperties;
}

/**
 * Check if a given object implements the ServiceRole interface.
 */
export function instanceOfServiceRole(value: object): value is ServiceRole {
    if (!('serviceAgreementUid' in value) || value['serviceAgreementUid'] === undefined) return false;
    if (!('partnerUid' in value) || value['partnerUid'] === undefined) return false;
    if (!('serviceRoleDefinition' in value) || value['serviceRoleDefinition'] === undefined) return false;
    return true;
}

export function ServiceRoleFromJSON(json: any): ServiceRole {
    return ServiceRoleFromJSONTyped(json, false);
}

export function ServiceRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceRole {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceRoleUid': json['serviceRoleUid'] == null ? undefined : json['serviceRoleUid'],
        'serviceAgreementUid': json['serviceAgreementUid'],
        'partnerUid': json['partnerUid'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'domicileCountry': json['domicileCountry'] == null ? undefined : json['domicileCountry'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'justification': json['justification'] == null ? undefined : json['justification'],
        'status': json['status'] == null ? undefined : json['status'],
        'serviceRoleDefinition': ServiceRoleDefinitionFromJSON(json['serviceRoleDefinition']),
        'partnerNumber': json['partnerNumber'] == null ? undefined : json['partnerNumber'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'partnerType': json['partnerType'] == null ? undefined : json['partnerType'],
        'stepMetadata': json['stepMetadata'] == null ? undefined : ((json['stepMetadata'] as Array<any>).map(StepMetadataFromJSON)),
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(TaskFromJSON)),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentV2FromJSON)),
        'isEligible': json['isEligible'] == null ? undefined : json['isEligible'],
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(StatusFromJSON)),
        'processInstanceId': json['processInstanceId'] == null ? undefined : json['processInstanceId'],
        'closingProcessInstanceId': json['closingProcessInstanceId'] == null ? undefined : json['closingProcessInstanceId'],
        'canBeDeactivated': json['canBeDeactivated'] == null ? undefined : json['canBeDeactivated'],
        'isEditable': json['isEditable'] == null ? undefined : json['isEditable'],
        'isRemovable': json['isRemovable'] == null ? undefined : json['isRemovable'],
        'productSpecificProperties': json['productSpecificProperties'] == null ? undefined : ProductSpecificServiceRolePropertiesFromJSON(json['productSpecificProperties']),
    };
}

export function ServiceRoleToJSON(json: any): ServiceRole {
    return ServiceRoleToJSONTyped(json, false);
}

export function ServiceRoleToJSONTyped(value?: ServiceRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceRoleUid': value['serviceRoleUid'],
        'serviceAgreementUid': value['serviceAgreementUid'],
        'partnerUid': value['partnerUid'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'domicileCountry': value['domicileCountry'],
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString().substring(0,10),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString().substring(0,10),
        'justification': value['justification'],
        'status': value['status'],
        'serviceRoleDefinition': ServiceRoleDefinitionToJSON(value['serviceRoleDefinition']),
        'partnerNumber': value['partnerNumber'],
        'fullName': value['fullName'],
        'partnerType': value['partnerType'],
        'stepMetadata': value['stepMetadata'] == null ? undefined : ((value['stepMetadata'] as Array<any>).map(StepMetadataToJSON)),
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(TaskToJSON)),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentV2ToJSON)),
        'isEligible': value['isEligible'],
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(StatusToJSON)),
        'processInstanceId': value['processInstanceId'],
        'closingProcessInstanceId': value['closingProcessInstanceId'],
        'canBeDeactivated': value['canBeDeactivated'],
        'isEditable': value['isEditable'],
        'isRemovable': value['isRemovable'],
        'productSpecificProperties': ProductSpecificServiceRolePropertiesToJSON(value['productSpecificProperties']),
    };
}

